module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * User: daletan
	 * Date: 3/12/16
	 * Time: 8:57 PM
	 * Copyright 1stdibs.com, Inc. 2016. All Rights Reserved.
	 */

	'use strict';

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	var React = __webpack_require__(1);
	var PropTypes = __webpack_require__(2);
	var classnames = __webpack_require__(3);
	var styles = __webpack_require__(4);

	/**
	 * @param {object} props
	 * @param {string} [props.additionalOverlayClasses]
	 * @param {string} [props.additionalSpinnerClasses]
	 * @param {string} [props.position="isFixed"] Accepts `isAbsolute`, `isStatic`, `isRelative`, defaults to `isFixed`
	*  @param {string} [props.size] only 'small' and 'medium' for now
	 * @returns
	 * @constructor
	 */
	var Overlay = function Overlay() {
	    var _classnames2, _classnames3;

	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var additionalWrapperClasses = props.additionalWrapperClasses,
	        additionalOverlayClasses = props.additionalOverlayClasses,
	        additionalSpinnerClasses = props.additionalSpinnerClasses,
	        _props$position = props.position,
	        position = _props$position === undefined ? "isFixed" : _props$position,
	        _props$size = props.size,
	        size = _props$size === undefined ? 'medium' : _props$size;

	    var wrapperClasses = classnames(_defineProperty({
	        'overlay-spinner-wrapper': true
	    }, additionalWrapperClasses, !!additionalWrapperClasses));
	    var overlayClasses = classnames((_classnames2 = {}, _defineProperty(_classnames2, styles.spinnerWrapper, styles.spinnerWrapper), _defineProperty(_classnames2, 'ajax-overlay', true), _defineProperty(_classnames2, additionalOverlayClasses, !!additionalOverlayClasses), _classnames2));
	    var spinnerClasses = classnames((_classnames3 = {}, _defineProperty(_classnames3, styles.large, size === 'large' && styles.large), _defineProperty(_classnames3, styles.medium, size === 'medium' && styles.medium), _defineProperty(_classnames3, styles.small, size === 'small' && styles.small), _defineProperty(_classnames3, 'tn-overlaySpinner', true), _defineProperty(_classnames3, additionalSpinnerClasses, !!additionalSpinnerClasses), _defineProperty(_classnames3, styles[position], !!position), _classnames3));
	    return React.createElement(
	        'div',
	        { className: wrapperClasses },
	        React.createElement('div', { className: overlayClasses }),
	        React.createElement('div', { className: spinnerClasses, 'data-tn': 'loading-check' })
	    );
	};

	Overlay.propTypes = {
	    additionalWrapperClasses: PropTypes.string,
	    additionalOverlayClasses: PropTypes.string,
	    additionalSpinnerClasses: PropTypes.string,
	    position: PropTypes.string,
	    size: PropTypes.oneOf(['large', 'medium', 'small'])
	};

	module.exports = Overlay;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	module.exports = require("react");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = require("prop-types");

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = require("classnames");

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"large":"_spinner__large__1nVe5","spin":"_spinner__spin__3Rf99","isFixed":"_spinner__isFixed__1TEmG","isAbsolute":"_spinner__isAbsolute__2m1Rz","isStatic":"_spinner__isStatic__1SdOj","isRelative":"_spinner__isRelative__1sFOo","medium":"_spinner__medium__2UQim","small":"_spinner__small__1DEW1"};

/***/ })
/******/ ]);


//////////////////
// WEBPACK FOOTER
// ./node_modules/dibs-overlay-spinner/dist/index.js
// module id = ./node_modules/dibs-overlay-spinner/dist/index.js
// module chunks = 4